<template>
  <div class="equipment">
    <img src="@/assets/images/img_bg@3x.png" class="back-ground" alt="">
    <div class="register-logo">
      <img src="@/assets/images/LOGO@2x.png" alt="">
    </div>
    <div class="add-equipment">
      <van-button icon="add-o" type="primary" class="add-equipment-button" @click="addEquipment">添加设备</van-button>
    </div>
    <div v-for="(item , index) of userDeviceCodeLists" :key="index" class="equipment-info">
      <van-field
        ref="keyword"
        v-model="item.deviceCode"
        label="文本"
        @input="handleContentChange(item)"
      >
        <template v-slot:label>
          <split-label label="出厂编号" />
        </template>
        <template #right-icon>
          <div style="display: flex; align-items: center">
            <van-icon name="scan" class="margin-right" size="20" @click="handleQrcode(index)" />
            <img src="@/assets/images/icon_delete@2x.png" alt="" class="compile-icon" @click="deleteInfo(index)">
          </div>
        </template>
      </van-field>
      <van-field
        ref="keyword"
        v-model="item.remark"
        label="文本"
      >
        <template v-slot:label>
          <split-label label="备注" />
        </template>
      </van-field>
      <van-field
        ref="keyword"
        v-model="item.model"
        readonly
        label="文本"
      >
        <template v-slot:label>
          <split-label label="型号" />
        </template>
      </van-field>
    </div>
    <div class="describe-button-around">
      <button class="describe-button" @click="handleSaveClick">保存</button>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  name: 'Equipment',
  data() {
    return {
      // 设备信息
      userDeviceCodeLists: [
        {
          remark: '',
          model: '',
          deviceCode: ''
        }
      ],
      indexDevice: '', // 设备生产线编号
      userDeviceInfoList: [], // 设备信息列表
      userDeviceCodeList: [] // 设备码列表
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    /*
  微信授权
*/
    handleWxConfig() {
      if (this.$store.state.isAndroid) {
        this.$api('OTHER_GET_JSSDK', {
          url: window.location.href
        }).then((res) => {
          if (res.code !== 200) return
          const { result } = res
          const timestamp = result.timestamp
          const appId = result.appId
          const nonceStr = result.nonceStr
          const signature = result.signature
          // 微信授权
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: nonceStr, // 必填，生成签名的随机串
            signature: signature, // 必填，签名
            jsApiList: ['startRecord', 'playVoice', 'uploadVoice', 'stopRecord', 'scanQRCode'] // 必填，需要使用的JS接口列表
          })
        })
      }
    },
    /*
* 微信扫码
* */
    handleQrcode(index) {
      if (this.wxBrowser === false) {
        this.$toast('普通游览器不支持扫码报修')
        return
      }
      const that = this
      // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          console.log(res.resultStr)
          that.userDeviceCodeLists[index].deviceCode = decodeURIComponent(res.resultStr.split('deviceCode=')[1])
          that.handleContentChange(that.userDeviceCodeLists[index])
        }
      })
    },
    /*
    * 监听用自动补全设备信息
    */
    handleContentChange(val) {
      let variable
      if (val.deviceCode.length > 5 && val !== variable) {
        this.$api('EQUIPMENT_INFO', {
          deviceCode: val.deviceCode
        }).then((res) => {
          if (res.code !== 200) return
          variable = val
          val.model = res.result.productModeDesc
        })
      }
    },
    /*
      添加设备
    */
    addEquipment() {
      this.userDeviceCodeLists.push(
        {
          remark: '',
          model: '',
          deviceCode: ''
        }
      )
    },
    /*
      设备生产线选择
    */
    showPopup(index) {
      this.indexDevice = index
      this.show = true
    },
    onConfirm(val) {
      this.userDeviceCodeLists[this.indexDevice].deviceCategoryName = val + ''
      this.show = false
    },
    /*
      删除设备
    */
    deleteInfo(index) {
      this.userDeviceCodeLists.splice(index, 1)
    },
    /*
      保存设备信息
    */
    handleSaveClick() {
      try {
        this.userDeviceInfoList = this.userDeviceCodeLists.map(item => {
          const { remark, model, deviceCode } = item
          if (item.deviceCode === '' || item.model === '') {
            throw new Error('设备信息不能为空')
          }
          return {
            remark,
            model,
            deviceCode
          }
        })
      } catch (e) {
        Toast('设备信息不能为空')
        return
      }

      if (this.userDeviceInfoList[0] === undefined) {
        this.$toast('请输入设备')
        return
      }
      this.$api('USER_DEVICE_EDIT_H5', {
        deviceCodeList: this.userDeviceInfoList
      }, true).then((res) => {
        if (res.code !== 200) {
          this.$toast(res.msg)
          return
        }
        this.$router.go(-1)
      })
    },
    /*
      获取用户信息
    */
    getInfo() {
      this.$api('USER_INFO_H5', {}, true).then((res) => {
        this.userDeviceCodeList = res.result.userDeviceCodeList
      })
    }
  }

}
</script>

<style scoped lang="scss">
  .margin-right {
    margin-right: 10px;
  }
  .equipment {
    display: flex;
    flex-direction: column;
    align-items: center;
    ::v-deep .dr__maintenance .base-info .info-item .info_value {
      flex: 1;
      margin-left: 0.65333rem;
      font-size: 0.37333rem;
      word-break: break-all;
      line-height: 0.36rem;
    }
    ::v-deep .dr__maintenance .base-info .info-item {
      .info_label {
        width: 68px;
        line-height: 0.36rem;
        font-size: 15px;
        .label span {
          font-size: 15px;
        }
      }
      .info_value {
        margin-left: 25.5px;
      }
    }
    ::v-deep .van-cell {
      font-size: 15px;
      display: flex;
      align-items: center;
    }
    ::v-deep .van-field__value {
      margin-left: 15.5px;
    }
    ::v-deep .van-field__control {
      color: #808C9B;
    }
    .equipment-popup {
      height: 245px;
    }
    .describe-button-around {
      position: absolute;
      top: 89.5%;
      width: 100%;
      margin-top: 25px;
      align-items: center;
      justify-content: center;
      .describe-button {
        width: 100%;
        height: 44px;
        background-color: #005BAC;
        border: none;
        font-size: 15px;
        color: #ffffff;
      }
    }
    .add-equipment {
      display: flex;
      width: 345px;
      justify-content: flex-end;
      .add-equipment-button {
        margin-bottom: 12.5px;
        padding: 8.5px;
        border-radius: 5px;
        width: 90px;
        height: 26.5px;
        background-color: #CEE1F7;
        border: none;
        color: #005BAC;
        font-size: 12px;
      }
    }
    .equipment-info {
      margin-bottom: 50px;
      width: 345px;
      background-color: #fff;
      .compile-icon {
        width: 17px;
        height: 17px;
      }
    }
    .back-ground{
      width: 100%;
      height: 100%;
      z-index: -999;
      position: absolute;
    }
    .register-logo{
      display: flex;
      justify-content: center;
      margin-bottom: 37px;
      img {
        width: 171px;
        height: 22px;
        margin-top: 30px;
      }
    }
  }
</style>
